export default __webpack_public_path__ + "static/media/football-1.75bf87df.png";